import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { config } from '../../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios'
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { GetMediumList } from '../../../Reducers/AffiliationCommonservice'
import { failureAlert, successAlert2 } from '../../../CommonUtils/SweetAlerts';
import { UseGetStatus } from '../../../CommonUtils/Commonstatus';
import { AC_YEAR_OLD } from '../../../CommonUtils/contextVariables';
function ChangeofMedium() {
    const ChnageMediumData = useSelector((state) => state?.commonMastersReducer?.Medium);
    const [getData, setData] = useState([])
    const hasFetchedData = useRef(false)
    const coursesFlags = useSelector((state) => state?.commonMastersReducer?.coursesFlags);
    const validationSchema = Yup.object().shape({
        isChangeMedium: Yup.string().required('required'),
        data: Yup.array().when('isChangeMedium', {
            is: 'true',
            then: Yup.array().of(
                Yup.object().shape({
                    mediumChange: Yup.string().required('required'),
                    mediumChangeName: Yup.string().when('mediumChange', {
                        is: 'true',
                        then: Yup.string().required('required').nullable(),
                        otherwise: Yup.string().notRequired()
                    })
                })
            ),
            otherwise: Yup.array().notRequired()
        })
    });

    const formik = useFormik({
        initialValues: {
            isChangeMedium: '',
            data: [{
                mediumChange: '',
                mediumChangeName: '',
                slno: ''
            }]
        },
        validationSchema: validationSchema,
        onSubmit: (val) => {
            if (
                val?.isChangeMedium === "null" ||
                val?.isChangeMedium === undefined ||
                val?.isChangeMedium === ""
            ) {
                Swal.fire({
                    title: 'Required Fields',
                    text: `Please Select 'Is College Applying for Any change in Medium for Any of the courses'.`,
                    icon: 'warning',
                    backdrop: false,
                    confirmButtonText: 'OK'
                });
                return;
            }

            let payload = [];

            if (val?.isChangeMedium == "false") {
                payload =
                    val?.data.map(row => ({
                        ...row,
                        slno: row?.slno,
                        isChangeMedium: val?.isChangeMedium,
                        mediumChange: '',
                        mediumChangeName: '',
                    }));


            } else {
                payload = val?.data.map(row => ({
                    ...row,
                    slno: row?.slno,
                    isChangeMedium: val?.isChangeMedium,
                    mediumChange: row?.mediumChange,
                    mediumChangeName: row?.mediumChangeName,
                }));
            }
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `saveChangeMedium`
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc)
                            GetData();
                            UseGetStatus();
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            })

        }
    })

    function GetData() {
        let url = config.url.API_URL + `getChangeMedium`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                let data = res?.data?.getChangeMedium
                setData(data)

                let updatedData = data.map((ac) => {
                    const mediumChange = ac?.medium_change?.toString();

                    const mediumChangeName = mediumChange === "true" ? ac?.medium_change_name || '' : '';
                    return {
                        mediumChange: mediumChange,
                        mediumChangeName: mediumChangeName,
                        slno: ac?.slno
                    };
                });
                formik.setFieldValue('data', updatedData);
            }
        })
    }

    const ClearValues = () => {
        if (getData?.length === 0) {

            formik.setFieldValue('data', [
                {
                    mediumChange: '',
                    mediumChangeName: '',
                }
            ]);
        }
    };
    useEffect(() => {
        formik?.setFieldValue('isChangeMedium', coursesFlags?.change_medium_flag?.toString());
        if (!hasFetchedData.current) {
            GetData();
            GetMediumList();
            hasFetchedData.current = true
        }
    }, [coursesFlags])

    return (
        <>
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit} onChange={formik.handleChange} className='affl-form'>
                    <h5>6. College Application for Change of Medium</h5>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className='form-control'>
                        <label htmlFor="isChangeMedium" className='me-2'>
                            Is College Applying for Any change in Medium for Any of the courses :
                        </label>
                        <div style={{ marginBottom: '10px' }}>
                            <Field as='select' name='isChangeMedium' className='form-control mt-2' style={{ width: 'auto' }}
                                onChange={(e) => { if (e?.target?.value === "false") { ClearValues(); } }}><option value=''>--SELECT--</option><option value="true">Yes</option><option value="false">No</option>
                            </Field>
                            <ErrorMessage name='isChangeMedium' className='text-error' component='div' style={{ color: 'red', fontSize: '12px', marginTop: '5px' }} />
                        </div>
                    </div>
                    {formik?.values?.isChangeMedium === 'true' && getData?.length > 0 && (<>
                        <div className="table-responsive mt-3">
                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>Sno</th>
                                        <th>Academic Program Type</th>
                                        <th>Course /Program</th>
                                        <th>Branch /Combination</th>
                                        <th>Medium</th>
                                        <th>Intake Approved for {AC_YEAR_OLD}</th>
                                        <th>Accreditation Conferred (NBA/NAAC)</th>
                                        <th>Affiliation Valid up to</th>
                                        <th>Change of Medium</th>
                                        <th>Change of medium To</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {getData?.map((ec, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td className='text-left'>{ec?.course_group_desc}</td>
                                            <td className='text-left'>{ec?.course_cat_name}</td>
                                            <td className='text-left'>{ec?.course_name}</td>
                                            <td>{ec?.name}</td>
                                            <td>{ec?.final_sanction_intake}</td>
                                            <td>{ec?.accredition}</td>
                                            <td>{ec?.affl_valid_upto ?? '-'}</td>
                                            <td>
                                                <Field as='select' name={`data[${i}].mediumChange`} className='form-control'
                                                    onChange={(e) => {
                                                        if (e.target.value === "false") {
                                                            formik.setFieldValue(`data[${i}].mediumChangeName`, '');
                                                        }
                                                    }}
                                                >
                                                    <option value="">--SELECT--</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Field>
                                                <ErrorMessage name={`data[${i}].mediumChange`} className='text-error' component='div' style={{ color: 'red', fontSize: '12px', marginTop: '5px' }} />
                                            </td>
                                            <td>
                                                {formik?.values.data[i]?.mediumChange === 'true' && (
                                                    <>
                                                        <Field as='select' name={`data[${i}].mediumChangeName`} className='form-control'>
                                                            <option value=''>--SELECT--</option>
                                                            {/* {ChnageMediumData && ChnageMediumData?.map((rel, i) => (<option value={rel?.medium_code}>{rel?.name}</option>))} */}
                                                            {ChnageMediumData &&
                                                                ChnageMediumData
                                                                    .filter((rel) => rel?.name !== ec?.name) // ✅ filter out the current medium
                                                                    .map((rel, j) => (
                                                                        <option key={j} value={rel?.medium_code}>
                                                                            {rel?.name}
                                                                        </option>
                                                                    ))}
                                                        </Field>
                                                        <ErrorMessage name={`data[${i}].mediumChangeName`} className='text-error' component='div' style={{ color: 'red', fontSize: '12px', marginTop: '5px' }} />
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                    )}
                    {getData.length > 0 || formik?.values?.isChangeMedium === 'false' ? (<>

                        <button type='submit' className='btn btn-success btn-sm float-end mt-3'>Submit</button><pre /><pre /><pre />
                    </>) : ((<center className='text-danger h5 pt-5'>***** No Data Found *****</center>))}

                </Form>
            </FormikProvider>
        </>
    )
}

export default ChangeofMedium
